import { useState } from "react";

import {
  articlesService,
  ArticlePayload,
} from "../../../apiServices/articles.service";

export const useCreateArticle = () => {
  const [loading, setLoading] = useState(false);

  const createArticle = async (payload: ArticlePayload) => {
    setLoading(true);

    try {
      return await articlesService.insert(payload);
    } finally {
      setLoading(false);
    }
  };

  return {
    createArticle,
    loading,
  };
};